import Block from './Block'
import { MarkerClusterer } from '@googlemaps/markerclusterer'

export default class Gmaps extends Block {
  getElems() {
    this.mapEl = this.el.querySelector('#map')
    this.map = null
    this.infoWindow = null
    this.select = this.el.querySelector('#countrySelect')
    this.markers = []
    this.country = null
    this.cards = [...document.querySelectorAll('.b-addresses__address')]

    /* eslint-disable */
    this.countryBounds = {
      'AR': { lat: -38.416097, lng: -63.616672, zoom: 4 },
      'AU': { lat: -25.274398, lng: 133.775136, zoom: 4 },
      'BR': { lat: -14.235004, lng: -51.92528, zoom: 4 },
      'CA': { lat: 56.130366, lng: -106.346771, zoom: 1 },
      'CN': { lat: 35.86166, lng: 104.195397, zoom: 4 },
      'CZ': { lat: 49.817492, lng: 15.472962, zoom: 6 },
      'DE': { lat: 51.165691, lng: 10.451526, zoom: 5 },
      'IN': { lat: 20.593684, lng: 78.96288, zoom: 5 },
      'ID': { lat: -0.789275, lng: 113.921327, zoom: 4 },
      'IT': { lat: 41.87194, lng: 12.56738, zoom: 5 },
      'JP': { lat: 36.204824, lng: 138.252924, zoom: 5 },
      'MY': { lat: 4.210484, lng: 101.975766, zoom: 6 },
      'NO': { lat: 60.472024, lng: 8.468946, zoom: 5 },
      'PH': { lat: 12.879721, lng: 121.774017, zoom: 5 },
      'PL': { lat: 51.919438, lng: 19.145136, zoom: 5 },
      'KR': { lat: 35.907757, lng: 127.766922, zoom: 6 },
      'RS': { lat: 44.016521, lng: 21.005859, zoom: 6 },
      'SG': { lat: 1.352083, lng: 103.819836, zoom: 10 },
      'ZA': { lat: -30.559482, lng: 22.937506, zoom: 5 },
      'ES': { lat: 40.463667, lng: -3.74922, zoom: 5 },
      'CH': { lat: 46.818188, lng: 8.227512, zoom: 7 },
      'TW': { lat: 23.69781, lng: 120.960515, zoom: 7 },
      'TH': { lat: 15.870032, lng: 100.992541, zoom: 5 },
      'TR': { lat: 38.963745, lng: 35.243322, zoom: 5 },
      'GB': { lat: 55.378051, lng: -3.435973, zoom: 5 },
      'US': { lat: 37.09024, lng: -95.712891, zoom: 4 },
      'BD': { lat: 23.685, lng: 90.3563, zoom: 6 },
      'BE': { lat: 50.8503, lng: 4.3517, zoom: 7 },
      'FR': { lat: 46.603354, lng: 1.888334, zoom: 5 },
      'GR': { lat: 39.0742, lng: 21.8243, zoom: 6 },
      'HK': { lat: 22.3193, lng: 114.1694, zoom: 10 },
      'HU': { lat: 47.1625, lng: 19.5033, zoom: 6 },
      'MA': { lat: 32.94074, lng: -7.533307, zoom: 7 },
      'PK': { lat: 30.3753, lng: 69.3451, zoom: 5 },
      'RO': { lat: 45.9432, lng: 24.9668, zoom: 6 },
      'LK': { lat: 7.8731, lng: 80.7718, zoom: 7 },
      'SE': { lat: 60.128161, lng: 18.643501, zoom: 6 },
      'VN': { lat: 14.0583, lng: 108.2772, zoom: 6 },
      'AZ': { lat: 40.1431, lng: 47.5769, zoom: 5 },
      'MX': { lat: 23.6345, lng: -102.5528, zoom: 5 },
      'HR': { lat: 45.1, lng: 15.2, zoom: 8 },
      'BG': { lat: 42.7339, lng: 25.4858, zoom: 6 },
      'PT': { lat: 39.3999, lng: -8.2245, zoom: 6 },
      'AL': { lat: 41.1533, lng: 20.1683, zoom: 7 },
      'DK': { lat: 56.2639, lng: 9.5018, zoom: 6 },
      'SA': { lat: 23.8859, lng: 45.0792, zoom: 5 },
      'QA': { lat: 25.276987, lng: 51.520008, zoom: 8 },
      'AE': { lat: 23.4241, lng: 53.8478, zoom: 7 }
    }
    /* eslint-enable */

    this.addresses = JSON.parse(this.el.querySelector('#mapData').dataset.addresses)
    this.blacklistedCountries = JSON.parse(this.el.querySelector('#mapData').dataset.blacklist)
  }

  bindMethods() {
    this._initMap = this._initMap.bind(this)
    this._filterByCountry = this._filterByCountry.bind(this)
    this._fetchMarkers = this._fetchMarkers.bind(this)
    this._openMarkerPopup = this._openMarkerPopup.bind(this)
  }

  init() {
    if (typeof google === 'undefined') {
      const script = document.createElement('script')

      window.initMap = this._initMap

      script.src =
        'https://maps.googleapis.com/maps/api/js?key=AIzaSyCw3ueCm3ounIGUU4YgaUrIzvPfLV6W4-Q&libraries=marker&callback=initMap'
      script.async = true

      document.head.appendChild(script)
    } else {
      this._initMap()
    }
  }

  events() {
    if (this.select) {
      this.select.addEventListener('change', () => {
        const country = this.select.value

        this._filterByCountry(country)
      })
    }
  }

  _initMap() {
    this.map = new google.maps.Map(this.mapEl, {
      zoom: 2,
      disableDefaultUI: true,
      zoomControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_CENTER
      },
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      rotateControl: false,
      scaleControl: false,
      center: {
        lat: 0,
        lng: 0
      },
      mapId: '56e3450c5857660f'
    })

    this.infoWindow = new google.maps.InfoWindow()

    this.select.value = 'CH'

    this._filterByCountry('CH')

    this._fetchMarkers()
  }

  _filterByCountry(country, skipMap = false) {
    if (!skipMap) {
      const bounds = this.countryBounds[country] || {
        lat: 0,
        lng: 0,
        zoom: 2
      }

      this.map.setCenter({
        lat: bounds.lat,
        lng: bounds.lng
      })
      this.map.setZoom(bounds.zoom)
    }

    this.cards.forEach((card) => {

      const display = country === '' || card.dataset.countryCode === country ? 'flex' : 'none';
      card.style.display = display;
      const image = document.querySelector(`.b-addresses-image__image[data-country-code="${card.dataset.countryCode}"]`);
      if (image) {
        image.style.display = display;
      }
    })
  }

  _fetchMarkers() {
    this.markers.forEach((marker) => marker.setMap(null))
    this.markers = []

    this.addresses.forEach((address) => {
      const countryCode = address.fields.adMaps.country_short
      const hideMarker = address.fields.adHideMarker

      if (this.blacklistedCountries.includes(countryCode) || hideMarker) return

      const marker = new google.maps.marker.AdvancedMarkerElement({
        map: this.map,
        position: {
          lat: parseFloat(address.fields.adMaps.lat),
          lng: parseFloat(address.fields.adMaps.lng)
        }
      })

      marker.countryCode = countryCode

      marker.addListener('click', () => {
        this._openMarkerPopup(marker)
      })

      this.markers.push(marker)
    })

    const clusterer = new MarkerClusterer({
      markers: this.markers,
      map: this.map
    })

    clusterer.addListener('click', (cluster) => {
      if (!cluster || !cluster.markers) return

      const clusterMarkers = cluster.markers
      const codes = clusterMarkers.map((m) => m.countryCode)
      const allSame = codes.every((val) => val === codes[0])

      if (clusterMarkers.length === 1) {
        this._openMarkerPopup(clusterMarkers[0])
      } else {
        const firstPos = clusterMarkers[0].position
        const samePosition = clusterMarkers.every(
          (m) =>
            m.position.lat === firstPos.lat &&
            m.position.lng === firstPos.lng
        )

        if (samePosition) {
          this._openMarkerPopup(clusterMarkers[0])
        } else if (allSame && codes[0]) {
          const country = codes[0]
          const bounds = this.countryBounds[country]

          if (bounds) {
            this.map.setCenter({
              lat: bounds.lat,
              lng: bounds.lng
            })
            this.map.setZoom(bounds.zoom)
            this._updateSelect(country)
          }
        } else {
          this.map.fitBounds(cluster.bounds)
        }
      }
    })
  }

  _openMarkerPopup(marker) {
    const address = this.addresses.find(
      (a) =>
        a.fields.adMaps.country_short === marker.countryCode &&
        parseFloat(a.fields.adMaps.lat) === marker.position.lat &&
        parseFloat(a.fields.adMaps.lng) === marker.position.lng
    )

    if (!address) return

    const infoWindowContent = `
      <div class="info-window-content">
        ${address.fields.adCustom}
      </div>
    `

    this._updateSelect(marker.countryCode)
    this.infoWindow.setContent(infoWindowContent)
    this.infoWindow.open(this.map, marker)
  }

  _updateSelect(countryCode) {
    if (this.select) {
      this.select.value = countryCode
      this._filterByCountry(countryCode, true)
    }
  }
}
